import { Dispatch, SetStateAction } from 'react';
import { clsx } from 'clsx';

import { RadioButtonChoice, RadioButtonProps } from '../radioButton.types';

export const RadioButtonDefault = ({
  id,
  isRequired,
  adminLabel,
  choice,
  setIsInvalid,
  customId,
  classNames,
}: {
  id: string;
  isRequired: boolean;
  choice: RadioButtonChoice;
  adminLabel: string;
  setIsInvalid: Dispatch<SetStateAction<boolean>>;
  customId: string;
  classNames?: RadioButtonProps['classNames'];
}) => {
  if (typeof choice === 'string') return null;
  return (
    <div
      className={clsx(
        'w-28 h-14 grow relative border-line group',
        classNames?.inputWrapper
      )}
      key={choice.text}
    >
      <input
        type='radio'
        className='opacity-0 absolute peer bottom-0 -right-1.5'
        id={id}
        name={adminLabel || customId}
        value={choice.value}
        required={isRequired}
        onInvalid={() => {
          setIsInvalid(true);
        }}
        onInput={() => {
          setIsInvalid(false);
        }}
      />
      <div
        className={clsx(
          'absolute inset-0 bg-white peer-checked:bg-link pointer-events-none duration-300'
        )}
      />
      <label
        className='peer-checked:text-white bg-transparent relative w-full h-full flex items-center justify-center cursor-pointer duration-300 group-hover:bg-link group-hover:text-white'
        htmlFor={id}
      >
        {choice.text}
      </label>
    </div>
  );
};
